import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-help',
  templateUrl: './help.component.html',
  styleUrls: ['./help.component.css'],
})
export class HelpComponent implements OnInit {
  link_lang: string = 'en-us';

  constructor() {}

  ngOnInit(): void {
    if (window.location.pathname.includes('/fr')) {
      this.link_lang = 'fr-fr';
    }
  }
}
